import { useRef, useEffect } from 'react';

const useDidMount = function () {
  let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};
  let deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const _isFirstUpdate = useRef(true);
  useEffect(() => {
    if (!_isFirstUpdate.current) {
      callback();
    }
    _isFirstUpdate.current = false;
  }, deps);
};

export { useDidMount as default };
